module.exports = __webpack_public_path__ + "img/95.31df8654.jpg";